import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';

/** Requests where the caller is the approver of the current pending step. Plain array, no pagination. */
export function usePendingTimeOffApprovals() {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useQuery({
    queryKey: TIME_OFF_KEYS.approvals(orgId),
    queryFn: ({ signal }) => timeOffService.getPendingApprovals(signal),
    staleTime: 30_000,
    enabled: !!orgId,
  });
}
